interface WindowWithHubspot extends Window {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly hbspt?: any;
}

class HubspotForms {
	region: string;
	forms: NodeListOf<HTMLElement>;
	constructor() {
		this.region = 'na1';
		this.forms = document.querySelectorAll('[data-hubspot-form]');
	}

	init() {
		window.addEventListener('load', () => {
			if (typeof window !== 'undefined' && window) {
				const windowWithHubspot: WindowWithHubspot = window;
				this.forms.forEach((form) => {
					const portalId = form.dataset.hubspotPortalId;
					const hubspotFormObject = {
						region: this.region,
						portalId,
						formId: form.dataset?.hubspotForm,
						target: '[data-hubspot-form="' + form.dataset?.hubspotForm + '"]',
						css: '',
						onFormReady() {
							window.dispatchEvent(new Event('resize'));
						},
					};
					windowWithHubspot.hbspt.forms.create(hubspotFormObject);
				});
			}
		});
	}
}

new HubspotForms().init();
